export enum ORDER_USER_STATUS {
	InSteps = 0,
	Rejected = 1,
	Validated = 2,
}
